module.exports = new __parcel__URL__("rollercoaster-tycoon.4d35d60a.jpg").toString();